import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountTypeService } from 'services';
import { AccountType } from 'models';

@Injectable({
	providedIn: 'root',
})
export class AccountTypesResolver implements Resolve<AccountType[]> {
	constructor(private accountTypeService: AccountTypeService) {}

	resolve(): Observable<AccountType[]> {
		return this.accountTypeService.get();
	}
}
